import { useState, useCallback } from 'react';
import {
    adminDeleteOrderAdminOrdersOrderIdDelete,
    AdminDeleteOrderAdminOrdersOrderIdDeleteData,
    getMinimalOrdersAdminOrdersMinimalGet,
    GetMinimalOrdersAdminOrdersMinimalGetData,
    getOrderByIdAdminOrderOrderIdGet,
    GetOrderByIdAdminOrderOrderIdGetData,
    toggleOrderStatusAdminOrderOrderIdStatusPatch,
    ToggleOrderStatusAdminOrderOrderIdStatusPatchData,
    updateOrderAdminOrdersOrderIdPut,
    UpdateOrderAdminOrdersOrderIdPutData,
    restoreOrderAdminOrdersOrderIdRestorePost,
    RestoreOrderAdminOrdersOrderIdRestorePostData,
} from "../client";

export const useOrder = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getOrderList = useCallback(async (data: GetMinimalOrdersAdminOrdersMinimalGetData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await getMinimalOrdersAdminOrdersMinimalGet(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const getOrderById = useCallback(async (data: GetOrderByIdAdminOrderOrderIdGetData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await getOrderByIdAdminOrderOrderIdGet(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const deleteOrder = useCallback(async (data: AdminDeleteOrderAdminOrdersOrderIdDeleteData) => {
        setLoading(true);
        setError(null);
        try {
            await adminDeleteOrderAdminOrdersOrderIdDelete(data);
            return true;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const restoreOrder = useCallback(async (data: RestoreOrderAdminOrdersOrderIdRestorePostData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await restoreOrderAdminOrdersOrderIdRestorePost(data);
            return response ? true : false;
        } catch (error: any) {
            setError(error.message);
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    const updateOrder = useCallback(async (data: UpdateOrderAdminOrdersOrderIdPutData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await updateOrderAdminOrdersOrderIdPut(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const updateOrderStatus = useCallback(async (data: ToggleOrderStatusAdminOrderOrderIdStatusPatchData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await toggleOrderStatusAdminOrderOrderIdStatusPatch(data);
            return response;
        } catch (error: any) {
            // 呼び出し元(orderFormDetail.tsx)がtry/catchで失敗時の表示を行う前提のため、
            // ここでエラーを握り潰さずに再throwする。握り潰すと呼び出し元のcatchが
            // 発火せず、APIが失敗してもUI上は成功したように見えてしまう。
            setError(error.message);
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        loading,
        error,
        getOrderList,
        deleteOrder,
        restoreOrder,
        updateOrder,
        getOrderById,
        updateOrderStatus
    };
};

export default useOrder;